import React from 'react';
import InputControl from '../../../containers/InputControl';
export default function HouseMemberCount(props) {
    return <InputControl {...props}></InputControl>;
}
